import { createBrowserRouter } from "react-router-dom";
import Index from ".";
import Absen from "./absen";
import AbsenHistory from "./absenhistory";
import PDFDownload from "./pdfdownload";
import QrAbsen from "./qrabsen";
import TransactionsPage from "./transaction";

export const router = () => {
    return createBrowserRouter([
        {
          path: "/",
          element: <Index />
        },
        {
          path: "/absen",
          element: <Absen />
        },
        {
          path: "/qrabsen",
          element: <QrAbsen />
        },
        {
          path: "/historyabsen",
          element: <AbsenHistory />
        },
        {
          path: "/pdfdownload",
          element: <PDFDownload />
        },
        {
          path: "/transaction",
          element: <TransactionsPage />
        },
        // {
        //   path: "/kas",
        //   element: <Kas/>
        // }
      ]);
}